const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEduPrograms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "24px",
    height: "24px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 24 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/education-programs"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    style: {
      stroke: "currentColor",
      strokeWidth: 0.2
    },
    d: "M11 11c0,1 0,1 -1,1 0,0 0,0 0,-1l0 -5 -8 -3 0 13 6 2c0,0 1,1 1,1 -1,0 -1,0 -1,0l-7 -2c0,0 0,0 0,0l0 -15 0 0c0,0 0,0 0,0 0,0 0,0 1,0l8 3 9 -3c0,0 0,0 1,0 0,0 0,0 0,0l0 0 0 9c0,1 -1,1 -1,1 0,0 0,0 0,-1l0 -8 -8 3 0 5zm12 6l0 1c0,0 0,1 0,1 -1,0 -1,0 -1,0l0 -1 0 1c0,0 0,0 -1,0 0,0 0,-1 0,-1l1 -1 0 -2 -7 2c0,0 0,0 -1,0l-3 -1 0 5c1,0 2,0 4,0 1,0 2,0 4,0l0 -3c0,0 0,0 0,0 0,0 1,0 1,0l0 3 0 0c0,0 -1,1 -1,1 -1,0 -3,0 -4,0 -2,0 -3,0 -5,0 0,0 0,0 0,-1l0 -5 -3 -1c0,0 0,0 0,0 0,-1 0,-1 0,-1l7 -2c1,0 1,0 1,0l7 2c0,0 1,1 1,1l0 2zm-13 -2c0,0 0,0 0,0 0,0 0,0 1,0l4 1 5 -1 -5 -2 -6 2 1 0zm3 -5c0,0 0,0 0,0 0,0 0,0 0,-1l3 0c0,0 0,0 1,0 0,0 0,0 -1,0l-3 1zm0 -2c0,0 0,0 0,0 0,-1 0,-1 0,-1l3 -1c0,0 0,0 1,1 0,0 0,0 -1,0l-3 1zm-7 4c0,0 0,0 0,0 0,0 0,1 0,0l-2 0c0,0 0,0 0,-1 0,0 0,0 1,0l1 1zm1 -3c1,1 1,1 1,1 0,0 -1,0 -1,0l-3 -1c0,0 0,0 0,0 0,0 0,0 1,0l2 0zm0 -2c1,0 1,0 1,1 0,0 -1,0 -1,0l-3 -1c0,0 0,0 0,0 0,-1 0,-1 1,-1l2 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEduPrograms);
export default __webpack_public_path__ + "static/media/edu-programs.8314415ca1b44e37214de6528d793840.svg";
export { ForwardRef as ReactComponent };